// extracted by mini-css-extract-plugin
export default {"Offer":"Offer_Offer__BQe8C","OfferItemContainer":"Offer_OfferItemContainer__Pe3SS"};